import axios from 'axios';
import { config } from '../config';
import { authHeader } from '../helpers';

// Inline axios instance
const api = axios.create({
  baseURL: '' // your base URL if needed
});

export const mddService = {
  getAll,
  getById,
  create,
  update,
  upload,
  remove
};

function getAll() {
  return api
    .get(`${config.mdd}/`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    })
    .then((res) => res.data);
}

function getById(id) {
  return api
    .get(`${config.mdd}/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    })
    .then((res) => res.data);
}

function create(data) {
  return api
    .post(`${config.mdd}/`, data, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    })
    .then((res) => res.data);
}

function update(id, data) {
  return api
    .put(`${config.mdd}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    })
    .then((res) => res.data);
}

function upload(formData, onUploadProgress) {
  return api
    .post(`${config.mdd}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...authHeader()
      },
      onUploadProgress
    })
    .then((res) => res.data);
}

function remove(id) {
  return api
    .delete(`${config.mdd}/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    })
    .then((res) => res.data);
}
